import IEnvConfig from "./IEnvConfig";

const DevEnv: IEnvConfig = {
    baseBackendUrl: 'https://factor-dev-ariel-api.azurewebsites.net'
};

export default DevEnv;
